import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hook';
import { handleSetSelectedCommunity, handleSetSelectedParentCommunity } from 'store/slices/globalSlice';

import CompanySpeedToLead from './CompanySpeedToLead';
import SpeedToLeadLatestRoot from './SpeedToLeadLatestRoot';

const SpeedToLeadRoute = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { selectedCommunity } = useAppSelector((state) => state.global);
  const isCommunity = searchParams.has('communityId');

  useEffect(() => {
    if (!isCommunity && selectedCommunity) {
      dispatch(handleSetSelectedCommunity(undefined));
      dispatch(handleSetSelectedParentCommunity(undefined));
    }
  }, [dispatch, isCommunity, selectedCommunity]);

  return isCommunity ? <SpeedToLeadLatestRoot /> : <CompanySpeedToLead />;
};

export default SpeedToLeadRoute;
